import {UPDATE_FAVORITES} from '../mutationTypes';

export default {
  [UPDATE_FAVORITES](state, {data}) {
    state.favorites = data;
  },
};
